import {userEndpoint} from "src/mrkt365config";
import {GET as CORE_GET} from "./helpers";

// url path formatter
const upf = (path = "") => userEndpoint+path;

const GET = (path = "") => CORE_GET(upf(path));

export const fetchCountryList = () => GET("get_all_countries");
